import styled from 'styled-components'
import { primary, textPrimary, greySecondary } from 'styles/Colors'

export const Container = styled.div`
  position: relative;
  width: 100%;
  background-color: white;
`

export const TabsHeader = styled.div`
  display: flex;
  border-bottom: 1px solid #e5e7eb;
  background-color: white;
  padding: 0 var(--dashboard-padding-x, 2.5rem);
`

export const Tab = styled.button`
  padding: 1rem 2rem;
  font-family: coresanscr55;
  font-size: 0.875rem;
  font-weight: 500;
  border: none;
  background: none;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  color: ${({ active }) => (active ? primary : textPrimary)};
  border-bottom-color: ${({ active }) => (active ? primary : 'transparent')};
  transition: all 0.2s ease;

  &:hover {
    color: ${primary};
    background-color: rgba(46, 77, 230, 0.05);
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(46, 77, 230, 0.2);
  }
`

export const TabContent = styled.div`
  padding: 2rem var(--dashboard-padding-x, 2.5rem);
  min-height: 500px;
  background-color: white;
`